var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHspIconGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#5f00a0",
    strokeWidth: 0.734,
    d: "M28.687 5.001S21.217 4.245 14.402 0C7.587 4.245.117 5.001.117 5.001-1.51 30.47 14.402 37.872 14.402 37.872s15.91-7.403 14.285-32.87z",
    transform: "translate(-11 -534) translate(12 535)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5f00a0",
    fillRule: "nonzero",
    d: "M23.053 12.423L17.655 12.423 17.655 7.102 11.162 7.102 11.162 12.423 5.763 12.423 5.763 18.824 11.162 18.824 11.162 24.145 17.655 24.145 17.655 18.824 23.053 18.824z",
    transform: "translate(-11 -534) translate(12 535)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#5f00a0",
    fillRule: "nonzero",
    d: "M37 22.072L40.072 19 37 15.944 37.944 15 41.944 19 37.944 23z",
    transform: "translate(-11 -534) translate(12 535)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHspIconGreen);
export default __webpack_public_path__ + "static/media/hsp_icon_green.35f5e10f89076402dfb096aa1813e063.svg";
export { ForwardRef as ReactComponent };